/**
 * financial.js — Core financial constants.
 */
export const FHSA_ANNUAL = 8000;
export const FHSA_LIFETIME = 40000;
export const SWR_DEFAULT = 0.04;
export const PENSION_PAYOUT_YRS = 25;
